import { render, staticRenderFns } from "./AssessmentQuestionV1.vue?vue&type=template&id=3d9d09a6&"
import script from "./AssessmentQuestionV1.vue?vue&type=script&lang=js&"
export * from "./AssessmentQuestionV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Kiosk.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports